import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { DotTypingLoader } from '../../../../loaders/dotTypingLoader'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { api } from '../../../../../services/api'
import { formatMoney } from '../../../../../Utils/formatMoney'
import { useEffect, useState, useCallback } from 'react'
import { Button } from '../../../../Button'
import { toast } from 'react-toastify'
import moment from 'moment'

import ModalOrders from '../ModalOrders';

import { Container } from './style'


export function OrdersTable() {
    const { listBusinessToFilter } = useAdministrativeContext()
    const [datasTable, setDatasTable] = useState([])
    const [page, setPage] = useState(1)
    const [tableLoading, setTableLoading] = useState(true)
    const [buttonLoading, setButtonLoading] = useState(false)
    const [open,setOpen] = useState(false) ///para abrir o modal
    const [dataProps,setDataProps] = useState({});

    const pullingDatas = useCallback(async (page) => {
        setButtonLoading(true)

        try{
            const response = await api.get(`/getOrdersTable/?business=${listBusinessToFilter}&page=${page}`)

            const { datas, next_page } = response.data
            
            const datasFormated = datas.map(d => {
                return {
                    RowNum: d.RowNum,
                    id: d.idOrcamento,
                    name: d.nmPessoa,
                    status: d.dsStatus,
                    price:  formatMoney(d.vlvalor),
                    date: moment(d.dtEmissao.slice(0, 16)).format('DD/MM/YYYY HH:mm'),
                    nameBusiness: d.nameBusiness    
                }
            })

            setDatasTable([...datasTable, ...datasFormated])

            setPage(next_page)
            setButtonLoading(false)
        }catch{
            toast.error('Algo deu errado')
        }
    }, [datasTable, listBusinessToFilter])

    
    async function allData(item){
        //http://192.168.15.10:3333/api/getOrder/14

        const response = await api.get(`getOrder/${item.id}`);
        //console.log(item)
        
        let id = item.id //numero do pedido
        let status = item.status //status do pedido
        let dsEmpresa = item.nameBusiness //nome da empresa
        
        let date = response.data.date //data
        let typeShopping = response.data.typeShopping//tipo de entrega
        let typeShoppingDescription = response.data.typeShoppingDescription //descricao da entrega
        let paymentMethod = response.data.paymentMethod //metodo de pagamento
        let feeDelivery = response.data.feeDelivery //taxa de entrega
        let subtotal = response.data.subtotal //subtotal
        let total = response.data.total //total
        let products = response.data.products //array dos produtos
        let address = response.data.address //endereço de entrega

        let dataObject={
            id: id,
            status: status,
            dsEmpresa: dsEmpresa,
            date: date,
            typeShopping: typeShopping,
            typeShoppingDescription: typeShoppingDescription,
            paymentMethod: paymentMethod,
            feeDelivery: feeDelivery,
            subtotal: subtotal,
            total: total,
            products: products,
            address: address
        }
        setDataProps(dataObject)

        setOpen(true);
    }


    useEffect(() => {
        async function fetchInitialData() {
            try{
                const response = await api.get(`/getOrdersTable/?business=${listBusinessToFilter}&page=1`)
          
                const { datas, next_page } = response.data
                
                const datasFormated = datas.map(d => {
                    return {
                        RowNum: d.RowNum,
                        id: d.idOrcamento,
                        name: d.nmPessoa,
                        status: d.dsStatus,
                        price:  formatMoney(d.vlvalor),
                        date: moment(d.dtEmissao.slice(0, 16)).format('DD/MM/YYYY HH:mm') ,
                        nameBusiness: d.nameBusiness  
                    }
                })
    
                setDatasTable(datasFormated)
    
                setPage(next_page)
    
                setTableLoading(false)
            }catch{
                toast.error('Algo deu errado')
            }
        }
        fetchInitialData()

    }, [listBusinessToFilter])



    if(tableLoading)
        return(
            <Container>
                <SpaceLoader colorLoader="#535354"/>
            </Container>
        )

    return(
        <Container>

            <table>

                <thead>
                    <tr>
                        <th></th>
                        <th>ID</th>
                        <th className="title-cliente"><p>CLIENTE</p></th>
                        <th >
                            DATA
                        </th>
                        <th className='isWideVersion'>
                            <p>VALOR</p>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {
                        datasTable.map(data => (
                            <tr key={data.RowNum} onClick={() => allData(data)}>
                                <td className={`${data.status}`}><div /></td>
                                <td>{data.id}</td>
                                <td className='name'>
                                     <p>{data.name}</p>
                                </td>

                                <td>
                                    {data.date}
                                </td>
                                <td className='isWideVersion'>
                                    <p>{data.price}</p>
                                </td>
                                
                            </tr>
                        ))
                    }
                </tbody>

            </table>

        {open ? 
            <ModalOrders
                onClose={() => setOpen(!open)}
                id={dataProps.id}
                status={dataProps.status}
                date={dataProps.date}
                dsEmpresa={dataProps.dsEmpresa}
                typeShopping={dataProps.typeShopping}
                typeShoppingDescription={dataProps.typeShoppingDescription}
                paymentMethod={dataProps.paymentMethod}
                feeDelivery={dataProps.feeDelivery}
                subtotal={dataProps.subtotal}
                total={dataProps.total}
                products={dataProps.products}
                address={dataProps.address}
            /> 
        : null}

        {page !== null &&
            <Button
                background="#7A05A7"
                color="#FFF"
                onClick={() => pullingDatas(page)}
            >
                {
                    buttonLoading ? 
                    <DotTypingLoader /> 
                    :
                    'Ver mais'
                }
            </Button>
        }

        </Container>
    )
}
